<template>
    <PageContainer fullscreen>
        <ScanPanel
            uri="/scan/devolution"
            :title="$t('customer.scan.devolution')"
        />
    </PageContainer>
</template>

<script setup lang="ts">
import ScanPanel from "@/components/elements/ScanPanel.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
</script>

<style scoped>
</style>
